import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Avatar } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  avatar: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.dark,
    height: 32,
    width: 32
  }
}));

export const TextAvatar = (props) => {
  const { name } = props;
  const classes = useStyles();
  return (
    <>
      {name && (
        <Avatar className={classes.avatar}>{name[0].toUpperCase()}</Avatar>
      )}
    </>
  );
};

TextAvatar.propTypes = {
  name: PropTypes.string.isRequired
};
